import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  Flex,
  Heading,
  Box,
  Button,
  HStack,
} from '@chakra-ui/react'

import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import TabelaCategoria from './TabelaCategoria/tabela-categoria';
import { listarCategorias } from '../../../api/categoria';
import Paginacao from '../../../components/common/paginacao/paginacao';

const GerenciarCategoria = () => {
  const [categorias, setCategorias] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [erro, setErro] = useState<string | null>(null);
  const navigate = useNavigate()

  useEffect(() => {
    const fetchCategorias = async () => {
      setLoading(true);
      setErro(null);
      try {
        const data = await listarCategorias(paginaAtual, itemsPerPage)

        // Log para diagnóstico
        console.log('Resposta da API de categorias:', data);

        // Trata múltiplos formatos possíveis de resposta
        let categoriasData = [];
        
        if (data.formatoArquivos && Array.isArray(data.formatoArquivos) && data.formatoArquivos.length > 0) {
          categoriasData = data.formatoArquivos;
        } else if (Array.isArray(data?.content)) {
          // Alternativa: dados em propriedade 'content'
          categoriasData = data.content;
        } else if (Array.isArray(data?.categorias)) {
          // Alternativa: dados em propriedade 'categorias'
          categoriasData = data.categorias;
        } else if (Array.isArray(data)) {
          // Alternativa: array direto
          categoriasData = data;
        }

        if (categoriasData.length > 0) {
          setCategorias(categoriasData.map((categoria: any) => ({
            seqCategoria: categoria.seqCategoria,
            dscCategoria: categoria.dscCategoria,
            datRegistro: categoria.datRegistro,
            numRegistro: categoria.numRegistro,
          })))
        } else {
          setCategorias([])
        }

        setTotalPages(data.totalPaginas || data.total || 1)

      } catch (error) {
        console.error('Erro ao buscar categorias:', error);
        setErro(error instanceof Error ? error.message : 'Erro desconhecido ao carregar categorias');
        setCategorias([]);
      } finally {
        setLoading(false);
      }
    }

    fetchCategorias()
  }, [paginaAtual, itemsPerPage])


  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Gerenciar Categorias
      </Heading>

      {/* Search bar */}
      <Box m="40px 0" w="100%">
        <HStack spacing={5}>
          <Button
            color="#fff"
            bgColor="#1789FC"
            _hover={{
              bgColor: "#1468C9"
            }}
            onClick={() => navigate('criar-categoria')}
          >
            Criar Categoria
          </Button>
        </HStack>
      </Box>

      {/* Debug info */}
      {erro && (
        <Box p="20px" bgColor="#f8d7da" borderRadius="4px" mb="20px" border="1px solid #f5c6cb" color="#721c24">
          <Heading size="sm" mb="10px">
            ⚠️ Erro ao carregar categorias
          </Heading>
          <Box fontSize="12px">
            <p>{erro}</p>
            <p style={{ marginTop: '10px' }}>Verifique o console (F12) para mais detalhes.</p>
          </Box>
        </Box>
      )}

      {!loading && categorias.length === 0 && !erro && (
        <Box p="20px" bgColor="#fff3cd" borderRadius="4px" mb="20px" border="1px solid #ffc107">
          <Heading size="sm" color="#856404" mb="10px">
            ℹ️ Nenhuma categoria carregada
          </Heading>
          <Box fontSize="12px" color="#856404">
            <p>Verifique o console (F12) para ver a resposta da API.</p>
            <p>Se há dados no backend, verifique se a API retorna no formato esperado.</p>
          </Box>
        </Box>
      )}

      <Box>
        <TabelaCategoria 
          listaCategoria={categorias} 
          listaVazia="Nenhum dado disponível." 
          loading={loading}
          />
      </Box>

      <Paginacao 
        paginaAtual={paginaAtual} 
        totalPages={totalPages} 
        onPageChange={setPaginaAtual}
      />
    </Flex>
  )
}

export default GerenciarCategoria
